import React from "react";
import {
  MarketingCampaignCTA,
  MarketingCampaignSecondaryCTA,
  MarketingCampaignAsset,
} from "@pollyslack/hub/src/types";
import { mrkdwnToHtml } from "./mrkdwn";

interface CampaignPreviewProps {
  headerText: string;
  bodyMrkdwn: string;
  asset?: MarketingCampaignAsset;
  primaryCTA: MarketingCampaignCTA;
  secondaryCTA?: MarketingCampaignSecondaryCTA;
}

export const CampaignPreview: React.FC<CampaignPreviewProps> = ({
  headerText,
  bodyMrkdwn,
  asset,
  primaryCTA,
  secondaryCTA,
}) => {
  const previewStyle: React.CSSProperties = {
    background: "#fff",
    border: "1px solid #ddd",
    borderRadius: 8,
    padding: 16,
    maxWidth: 500,
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif',
    fontSize: 14,
    lineHeight: "1.5",
    color: "#1d1c1d",
  };

  const headerStyle: React.CSSProperties = {
    fontSize: 18,
    fontWeight: 900,
    marginBottom: 8,
  };

  const dividerStyle: React.CSSProperties = {
    border: "none",
    borderTop: "1px solid #ddd",
    margin: "8px 0",
  };

  const buttonStyle: React.CSSProperties = {
    display: "inline-block",
    padding: "8px 16px",
    borderRadius: 4,
    fontSize: 14,
    fontWeight: 700,
    cursor: "default",
    marginRight: 8,
    marginTop: 8,
  };

  const primaryBtnStyle: React.CSSProperties = {
    ...buttonStyle,
    background: "#007a5a",
    color: "#fff",
    border: "none",
  };

  const secondaryBtnStyle: React.CSSProperties = {
    ...buttonStyle,
    background: "#fff",
    color: "#333",
    border: "1px solid #ddd",
  };

  const contextStyle: React.CSSProperties = {
    fontSize: 12,
    color: "#616061",
    marginTop: 8,
  };

  return (
    <div style={previewStyle}>
      <div style={headerStyle}>{headerText}</div>
      <hr style={dividerStyle} />
      <div
        dangerouslySetInnerHTML={{
          __html: mrkdwnToHtml(bodyMrkdwn || ""),
        }}
      />
      {asset?.url && (
        <img
          src={asset.url}
          alt={asset.altText || "Campaign image"}
          style={{
            maxWidth: "100%",
            borderRadius: 4,
            marginTop: 8,
          }}
        />
      )}
      <div style={{ marginTop: 12 }}>
        <span style={primaryBtnStyle}>{primaryCTA?.label || "CTA"}</span>
        {secondaryCTA?.mode === "button" && secondaryCTA.button && (
          <span style={secondaryBtnStyle}>{secondaryCTA.button.label}</span>
        )}
        {secondaryCTA?.mode === "dropdown" &&
          secondaryCTA.dropdownOptions?.length > 0 && (
            <span style={secondaryBtnStyle}>More options ▾</span>
          )}
      </div>
      <div style={{ height: 16 }} />
      <hr style={dividerStyle} />
      <div style={contextStyle}>
        Reply 'unsubscribe' to opt out of product communications.
      </div>
    </div>
  );
};
